import { render } from "./ContatoView.vue?vue&type=template&id=2355a678&scoped=true"
import script from "./ContatoView.vue?vue&type=script&lang=js"
export * from "./ContatoView.vue?vue&type=script&lang=js"

import "./ContatoView.vue?vue&type=style&index=0&id=2355a678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2355a678"]])

export default __exports__